<script setup lang="ts">
/** Sélecteur de technicien assignable — alimente SearchableSelect via le store. */
import { computed, onMounted } from 'vue'
import SearchableSelect from '@/v2/components/common/SearchableSelect.vue'
import { useAccompagnementStore } from '@/v2/accompagnement/store/useAccompagnementStore'

const props = defineProps<{ modelValue: string; id?: string; placeholder?: string }>()
const emit = defineEmits<{ 'update:modelValue': [string] }>()

const store = useAccompagnementStore()

onMounted(() => {
  if (!store.technicians.length) void store.fetchTechnicians()
})

const options = computed(() =>
  store.technicians.map((t) => ({
    value: t.uuid,
    label: `${t.name} · ${t.openCount} en cours`,
  })),
)
</script>

<template>
  <SearchableSelect
    :id="id"
    :model-value="modelValue"
    :options="options"
    :placeholder="placeholder ?? 'Choisir un technicien…'"
    search-placeholder="Rechercher un technicien…"
    clearable
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
